import axiosInstance from "auth/FetchInterceptor";
import { PREFIX } from "constants/ApiConstant";
const PhanCaTrucService = {};

PhanCaTrucService.search = function (data) {
  return axiosInstance.post(`${PREFIX}/PhanCaTruc/search`, data);
};

PhanCaTrucService.detail = function (data) {
  const path =
    data && (data.khoaId || data.isTruc)
      ? `&khoaId=${data?.khoaId || ""}&isTruc=${data?.isTruc || false}`
      : "";
  return axiosInstance.get(`${PREFIX}/PhanCaTruc/detail?id=${data.id}${path}`);
};

PhanCaTrucService.upsert = function (data) {
  return axiosInstance.post(`${PREFIX}/PhanCaTruc/up-sert`, data);
};

PhanCaTrucService.hideColumn = function (data) {
  return axiosInstance.put(`${PREFIX}/PhanCaTruc/hide-column`, data);
};

PhanCaTrucService.upSertPhanCaTrucChiTiet = function (data) {
  return axiosInstance.post(`${PREFIX}/PhanCaTruc/ChiTiet/up-sert`, data);
};

PhanCaTrucService.export = function (id) {
  return axiosInstance.get(`${PREFIX}/PhanCaTruc/ChiTiet/export-excel/${id}`);
};

PhanCaTrucService.copy = function (data) {
  return axiosInstance.post(`${PREFIX}/PhanCaTruc/copy`, data);
};

PhanCaTrucService.getAllThietLapViTri = function (branchId) {
  return axiosInstance.get(
    `${PREFIX}/PhanCaTruc/ThietLapViTri/search?branchId=${branchId}`,
  );
};

PhanCaTrucService.getThietLapViTriById = function (id) {
  return axiosInstance.get(
    `${PREFIX}/PhanCaTruc/ThietLapViTri/detail?id=${id}`,
  );
};

PhanCaTrucService.upsertThietLapViTri = function (data) {
  return axiosInstance.post(`${PREFIX}/PhanCaTruc/ThietLapViTri/up-sert`, data);
};

PhanCaTrucService.getPhanCaTrucHeaderTableByBranchId = function (branchId) {
  return axiosInstance.get(
    `${PREFIX}/PhanCaTruc/ThietLapViTri/get-header-table?branchId=${branchId}`,
  );
};

PhanCaTrucService.searchPhieuDoiLich = function (data) {
  return axiosInstance.post(
    `${PREFIX}/PhanCaTruc/PhieuDoiLichTruc/search`,
    data,
  );
};

PhanCaTrucService.getPhieuDoiLich = function (id) {
  return axiosInstance.get(
    `${PREFIX}/PhanCaTruc/PhieuDoiLichTruc/detail?id=${id}`,
  );
};

PhanCaTrucService.getDanhSachTongHop = function (data) {
  return axiosInstance.get(
    `${PREFIX}/PhanCaTruc/ChiTiet/tong-hop?id=${data.id}&branchId=${data.branchId}`,
  );
};

PhanCaTrucService.upSertPhieuDoiLich = function (data) {
  return axiosInstance.post(
    `${PREFIX}/PhanCaTruc/PhieuDoiLichTruc/up-sert`,
    data,
  );
};

PhanCaTrucService.getPhieuDoiLichByNgayTruc = function (data) {
  return axiosInstance.post(
    `${PREFIX}/PhanCaTruc/PhieuDoiLichTruc/get-by-ngay-truc`,
    data,
  );
};

PhanCaTrucService.searchPhieuDoiLichNghi = function (data) {
  return axiosInstance.post(
    `${PREFIX}/PhanCaTruc/PhieuDoiLichNghi/search`,
    data,
  );
};

PhanCaTrucService.getPhieuDoiLichNghi = function (id) {
  return axiosInstance.get(
    `${PREFIX}/PhanCaTruc/PhieuDoiLichNghi/detail?id=${id}`,
  );
};

PhanCaTrucService.upSertPhieuDoiLichNghi = function (data) {
  return axiosInstance.post(
    `${PREFIX}/PhanCaTruc/PhieuDoiLichNghi/up-sert`,
    data,
  );
};

PhanCaTrucService.searchLichLamViec = function (data) {
  return axiosInstance.post(
    `${PREFIX}/PhanCaTruc/LichLamViec/search`,
    data
  );
};

PhanCaTrucService.exportLichLamViec = function (data) {
  return axiosInstance.post(
    `${PREFIX}/PhanCaTruc/LichLamViec/export-excel`,
    data
  );
};

export default PhanCaTrucService;
